module.exports = __webpack_public_path__ + "static/media/IMG_0301.72c291eb.JPG";